export function isDark(color) {
    const hex = color.replace('#', '');
    const r = parseInt(hex.substr(0, 2), 16);
    const g = parseInt(hex.substr(2, 2), 16);
    const b = parseInt(hex.substr(4, 2), 16);
    const brightness = (r * 299 + g * 587 + b * 114) / 1000;
    return brightness < 128;
  }
  
  
export function stringToLightColor(string) {
    let hash = 0;
    let i;
    for (i = 0; i < string.length; i += 1) {
        hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }
    let color = '#';
    for (i = 0; i < 3; i += 1) {
        const value = ((hash >> (i * 8)) & 0xFFFFFF) % 150 + 100; // Restricting the range to lighter colors
        color += `00${value.toString(16)}`.slice(-2);
    }
    return color;
  }
  
  
export function stringAvatar(name) {
    if (typeof name !== 'string' || name.trim() === '') {
      return {
        sx: {
          fontFamily: 'DM Sans Medium',
          border:'none',
          fontSize: '14px',
          letterSpacing: 1,
          bgcolor: '#CCCCCC', 
          color: '#000000',  
        },
        children: '',
      };
    }
    const names = name.trim().split(' ');
    const initials = names.length > 1
      ? `${names[0][0].toUpperCase()}${names[1][0].toUpperCase()}`
      : names[0][0].toUpperCase();
    
    const backgroundColor = stringToLightColor(name); 
    const color = isDark(backgroundColor) ? '#FFFFFF' : '#000000'; 
    return {
      sx: {
        fontFamily: 'DM Sans Medium',
        border:'none',
        fontSize: '14px',
        letterSpacing: 1,
        bgcolor: backgroundColor,
        color: color,
      },
      children: initials,
    };
  }
  